import React, { FunctionComponent } from 'react'
import styles from './TimelineIcon.module.scss'
import { TimelineIconProps } from './TimelineIcon.model'
import { ColorsV2 } from '../../../../design-system/colors_v2'
import { Icon, IconsType } from '../../../shared'
import classnames from 'classnames/bind'
import { TimelineEventType } from '../../../../model/MedicalEvent'
import { DocumentCategoryIcon, DocumentCategoryKeys } from '../../../../model/DocumentCategory'

const classnamesCx = classnames.bind(styles)

export const TIMELINE_TYPE_TO_ICON: { [type in TimelineEventType]: IconsType } = {
  ...DocumentCategoryIcon,
  // Static Types
  AddMedicalEventAction: 'add',
  CreatedPatientEvent: 'profile',
  MedicalEvent: 'default',
}

// The API can send categories the front has no picto for (e.g. the interop stay ones:
// hospitalization, consultation...). They are shown as "other" instead of falling back to the
// generic "forbidden" icon.
const resolveIconType = (type: TimelineEventType): TimelineEventType =>
  type in TIMELINE_TYPE_TO_ICON ? type : DocumentCategoryKeys.Other

export const TimelineIcon: FunctionComponent<TimelineIconProps> = ({ type, onClick }) => {
  const iconType = resolveIconType(type)
  const icon = TIMELINE_TYPE_TO_ICON[iconType]
  return (
    <div
      className={classnamesCx(styles.icon, { [iconType]: true })}
      onClick={onClick}
      data-test-id={`timeline-icon-${type}`}
    >
      <Icon color={ColorsV2.contentLight1} icon={icon} size="micro" />
    </div>
  )
}
